import axios from 'axios';

const baseURL = process.env.NODE_ENV === "production" ? 'https://sipr.freeddns.org' : 'http://chestnut.jesuitas.vpn:8000';

const apiClient = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});


apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 403) {
      console.error("CSRF or Permission Error");
    }
    return Promise.reject(error);
  }
);


apiClient.interceptors.request.use(async (config) => {
  const method = config.method.toLowerCase();
  const unsafeMethods = ['post', 'put', 'delete', 'patch'];

  if (unsafeMethods.includes(method)) {
    try {
      await axios.get(baseURL + '/', { withCredentials: true })
        .then(response => localStorage.setItem("user_csrf_token", response.data.token));
    } catch (error) {
      console.error("Could not refresh CSRF token", error);
    }
  }

  const token = localStorage.getItem('user_csrf_token');
  if (token) {
      config.headers['X-CSRFToken'] = token;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

export default apiClient;
